import type { FaireProductEntity } from "../../entity_types/product";

export const p_29ybz34ejs: FaireProductEntity = {
  token: "p_29ybz34ejs",
  type: "product",
  name: "Triple Tree - Custom - Toddler Long Sleeve Tee",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/29a7d79c44bcf8276ff633e6364a10ff15e8b50f709eb017ef8484716711fd30.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33a565e2b7ac54c8ab09f9de9a051c78435a1b767f6739b7152c6890d0b97812.png",
    "https://cdn.faire.com/fastly/be52f7150813f32739b3969c2053a26d28c6fcf41be557702ba23a346882a43a.png",
    "https://cdn.faire.com/fastly/3b3ace01a864cc50b820d6d06648ba7200b67637070e7409aceb5e8af29b2e40.png"
  ],
  priceDollars: 13,
  description: "Our Triple Tree graphic is now available on a toddler sized Long Sleeve tee.\nWe can offer in four colors and sizes 2T, 3T, 4T and 5/6.\n\nWe will replace Montana, Maine, Vermont and Breckenridge with your location. Please provide our customization request in the space provided.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:49.231Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
